import { startOneTimePasscode } from '../helpers/start-one-time-passcode';
import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';

interface StartOneTimePasscodeFnPayload {
    identityId: string;
    otpOption: 'email' | 'phone';
    language: string;
}

export type StartOneTimePasscodeFn = (
    payload: StartOneTimePasscodeFnPayload,
) => Promise<unknown>;

export function initStartOneTimePasscodeFn({
    dependencies,
}: DomainInitPayload): StartOneTimePasscodeFn {
    return async ({
        identityId,
        otpOption,
        language,
    }: StartOneTimePasscodeFnPayload) => {
        await startOneTimePasscode(
            {
                identityId,
                otpOption,
                language,
            },
            dependencies,
        );
    };
}
